import { useMemo, useSyncExternalStore } from 'react';
import { createPath, Router, type DataRouter, type Navigator } from 'react-router';

type HostRouterProps = {
  router: DataRouter;
  children: React.ReactNode;
};

export function HostRouter({ router, children }: HostRouterProps) {
  const state = useSyncExternalStore(router.subscribe, () => router.state);
  const navigator = useMemo<Navigator>(
    () => ({
      createHref: (to) =>
        router.createHref(new URL(typeof to === 'string' ? to : createPath(to), window.location.origin)),
      go: (delta) => {
        router.navigate(delta);
      },
      push: (to, navigationState) => {
        router.navigate(to, { state: navigationState });
      },
      replace: (to, navigationState) => {
        router.navigate(to, { state: navigationState, replace: true });
      },
    }),
    [router],
  );
  return (
    <Router location={state.location} navigationType={state.historyAction} navigator={navigator}>
      {children}
    </Router>
  );
}
